import { Icon } from '@aibees/shared/components';
import { classnames, fCredit } from '@aibees/shared/utils';
import { CardContent, Stack, Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditEffectProps as Props } from './types';

export const CreditEffect = memo(
  ({ className, label, creditAmount, sx }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('CreditEffect', className)}
        sx={mergeSx(SX.root, sx)}
        variant="outlined"
      >
        <CardContent padding="normal" sx={SX.cardContent}>
          <Typography
            className={classnames('CreditLabel')}
            variant="body3"
            color="grey.700"
            fontWeight={500}
          >
            {label}
          </Typography>
          <Stack direction="row" alignItems="center" gap={1.5}>
            <Typography
              className={classnames('credit-value')}
              variant="body3"
              fontWeight={500}
              color="common.black"
            >
              {fCredit(creditAmount)}
            </Typography>{' '}
            <Icon name="coin" size={18} />
          </Stack>
        </CardContent>
      </Styled.Wrapper>
    );
  }
);

CreditEffect.displayName = 'CreditEffect';
